import React from 'react';
import Image from 'react-bootstrap/Image';
import cx from 'classnames';
import PropTypes from 'prop-types';

const Product = ({ photos, name, details, id }) => {
    const { main } = photos;
    const { price, quantity, shippingLabel } = details;

    const imageClasses = cx('product__thumbnail');

    return (
        <li className="product__item" id={`product-${id}`}>
            <div className={imageClasses}>
                <Image src={main.thumbnail} />
            </div>
            <div className="product__detail">
                <div className="product__detail--header">
                    <div className="product__price">
                        <span className="product__price--current">{`${price.current} ${price.currency}`}</span>
                        {price.old && <span className="product__price--old">{`${price.old} ${price.currency}`}</span>}
                    </div>
                    <div
                        className="product__name"
                        dangerouslySetInnerHTML={{ __html: name }}
                    />
                </div>
                <ul className="product__attributes">
                    <li className="product__attributes--item">
                        Ilość: <strong>{`${quantity}`}</strong>
                    </li>
                    {shippingLabel && <li className="product__attributes--item">
                        Wysyłka: <strong>{`${shippingLabel}`}</strong>
                    </li>}
                </ul>
            </div>
        </li>
    );
};

Product.propTypes = {
    photos: PropTypes.object,
    name: PropTypes.string,
    details: PropTypes.object,
    id: PropTypes.string,
};
export default Product;
